var map = {
	"./discover": 95,
	"./discover.jsx": 95,
	"./home": 68,
	"./home.jsx": 68,
	"./login": 66,
	"./login.js": 66,
	"./message": 64,
	"./message/": 64,
	"./message/[id]": 94,
	"./message/[id].js": 94,
	"./message/index": 64,
	"./message/index.jsx": 64,
	"./post/[id]": 90,
	"./post/[id].js": 90,
	"./profile/[id]": 93,
	"./profile/[id].js": 93,
	"./register": 67,
	"./register.js": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;